import React, { Component } from "react";

// ── Checkbox Multi-select Dropdown ────────────────────────────────────────────
// Shared "All (N)" style multi-select used by the students filter bar and the OMR
// status filter bar. Props: options [{value,label}], value [ids], onChange(ids),
// placeholder.
export default class CheckboxDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }

    handleOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target)) {
            this.setState({ open: false });
        }
    };

    toggle = (id) => {
        const { value, onChange } = this.props;
        onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
    };

    render() {

        const { options, value, placeholder } = this.props;
        const { open } = this.state;
        const label = value.length === 0
            ? placeholder
            : value.length === options.length
                ? `All (${options.length})`
                : value.length === 1
                    ? (options.find(o => o.value === value[0])?.label || `${value.length} selected`)
                    : `${value.length} selected`;

        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div
                    onClick={() => this.setState({ open: !open })}
                    style={{ borderRadius: 8, border: "1.5px solid #e5e7eb", height: 42, padding: "0 14px", fontSize: 13.5, color: value.length ? "#1f2937" : "#9ca3af", background: "#fff", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none" }}
                >
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fas fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 10, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>

                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 220, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div
                                    onClick={() => this.props.onChange(value.length === options.length ? [] : options.map(o => o.value))}
                                    style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#7C3AED", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}
                                >
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#7C3AED" }} />
                                    Select All
                                </div>
                                {options.map(o => (
                                    <div
                                        key={o.value}
                                        onClick={() => this.toggle(o.value)}
                                        style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}
                                    >
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#7C3AED" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6D28D9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
